export const EXPORT_DOCUMENT_MAPPING_REQUEST = 'EXPORT_DOCUMENT_MAPPING_REQUEST';
export const EXPORT_DOCUMENT_MAPPING_SUCCESS = 'EXPORT_DOCUMENT_MAPPING_SUCCESS';
export const EXPORT_DOCUMENT_MAPPING_FAILURE = 'EXPORT_DOCUMENT_MAPPING_FAILURE';

export const DATA_CENTER_AUTOMATION_SAVE_BULK_REQUEST = 'DATA_CENTER_AUTOMATION_SAVE_BULK_REQUEST';
export const DATA_CENTER_AUTOMATION_SAVE_BULK_SUCCESS = 'DATA_CENTER_AUTOMATION_SAVE_BULK_SUCCESS';
export const DATA_CENTER_AUTOMATION_SAVE_BULK_FAILURE = 'DATA_CENTER_AUTOMATION_SAVE_BULK_FAILURE';

export const DATA_CENTER_AUTOMATION_LIST_REQUEST = 'DATA_CENTER_AUTOMATION_LIST_REQUEST';
export const DATA_CENTER_AUTOMATION_LIST_SUCCESS = 'DATA_CENTER_AUTOMATION_LIST_SUCCESS';
export const DATA_CENTER_AUTOMATION_LIST_FAILURE = 'DATA_CENTER_AUTOMATION_LIST_FAILURE';

export const DOCUMENT_MAPPINGS_REQUEST = 'DOCUMENT_MAPPINGS_REQUEST';
export const DOCUMENT_MAPPINGS_SUCCESS = 'DOCUMENT_MAPPINGS_SUCCESS';
export const DOCUMENT_MAPPINGS_FAILURE = 'DOCUMENT_MAPPINGS_FAILURE';

export const FOLDER_PATH_TEST_CONNECTION_REQUEST = 'FOLDER_PATH_TEST_CONNECTION_REQUEST';
export const FOLDER_PATH_TEST_CONNECTION_SUCCESS = 'FOLDER_PATH_TEST_CONNECTION_SUCCESS';
export const FOLDER_PATH_TEST_CONNECTION_FAILURE = 'FOLDER_PATH_TEST_CONNECTION_FAILURE';
